import { Button } from "~/components";

const HomeCatalog = () => {
  return (
    <section
      className="max-md:pb-0 max-md:pt-[90px] bg-[url('/img/main-bg.png')] bg-no-repeat bg-cover max-md:bg-[53%_50%] bg-center pt-[124px] pb-[140px]"
      id="home"
    >
      <div className="container ">
        <div className="">
          <h1 className="max-lg:text-[40px] max-lg:leading-[55px] text-center text-white text-5xl font-extrabold uppercase leading-[80px]">
            Your #1 Romance Audiobook App
          </h1>
          <h3 className="max-lg:text-[28px] max-lg:leading-[39px] uppercase leading-[50px] text-4xl text-white text-center mt-2 max-md:mb-6">
            with Unlimited Listening
          </h3>
          <p className="max-md:hidden max-lg:mt-4 max-lg:mb-6 max-lg:text-xl max-lg:leading-7 text-center text-white text-[23px] font-light tracking-tight mt-10 mb-9">
            Enjoy bestsellers and top professional voices.
          </p>
          <div className="flex justify-center max-md:px-4 max-md:mb-6">
            <Button className="max-md:w-full max-md:px-0 px-24" />
          </div>
        </div>
      </div>
    </section>
  );
};

HomeCatalog.disolayName = "HomeCatalog";
export default HomeCatalog;
